import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
  copyFormattedToClipboard,
  copyHtmlToClipboard,
  copyTextToClipboard,
} from "./formatting";

type FormatterOutputPanelProps = {
  output: string;
  format?: "html" | "text";
  title?: string;
  cardClassName?: string;
  framed?: boolean;
};

export default function FormatterOutputPanel({
  output,
  format = "html",
  title = "Output",
  cardClassName,
  framed = true,
}: FormatterOutputPanelProps) {
  const isHtml = format === "html";

  const content = (
    <>
      {title ? (
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
      ) : null}
      <CardContent>
        {isHtml ? (
          <div
            className="output-html min-h-[260px] rounded-lg border border-slate-200 bg-white p-4 text-sm leading-6"
            dangerouslySetInnerHTML={{ __html: output }}
          />
        ) : (
          <div className="min-h-[260px] whitespace-pre-wrap rounded-lg border border-slate-200 bg-white p-4 text-sm leading-6">
            {output}
          </div>
        )}
        <div className="mt-4 flex flex-wrap gap-2">
          {isHtml ? (
            <Button onClick={() => copyHtmlToClipboard(output)}>Copy HTML</Button>
          ) : null}
          <Button variant="secondary" onClick={() => copyFormattedToClipboard(output, format)}>
            Copy Formatted
          </Button>
          <Button variant="ghost" onClick={() => copyTextToClipboard(output, format)}>
            Copy Text
          </Button>
        </div>
        <pre className="mt-4 min-h-[120px] whitespace-pre-wrap rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs">
          {output}
        </pre>
      </CardContent>
    </>
  );

  if (!framed) return <div className={cardClassName}>{content}</div>;
  return <Card className={cardClassName}>{content}</Card>;
}
